import { useEffect, useState } from 'react';

import getQueryString from '../../../helpers/getQueryString';

const useShowOverlay = (urlParamFlag: string) => {
    const [showOverlay, setShowOverlay] = useState(false);

    useEffect(() => {
        if (!getQueryString(urlParamFlag)) {
            return;
        }

        setShowOverlay(true);
    }, [urlParamFlag]);

    return {
        showOverlay,
    };
};

export default useShowOverlay;
